import type { Product } from "@/data/productDatabase";
import { getProductImage } from "@/data/productImages";

/** Brand → accent color mapping */
const BRAND_COLORS: Record<string, string> = {
  "Sundown Audio": "#e8782a",
  "JL Audio": "#c9261f",
  "Skar Audio": "#22c55e",
  "Rockford Fosgate": "#3b82f6",
  "Kicker": "#facc15",
  "Alpine": "#0ea5e9",
  "Fi Audio": "#a855f7",
  "DD Audio": "#ef4444",
  "Taramps": "#10b981",
  "Crescendo Audio": "#f97316",
  "CT Sounds": "#64748b",
  "Focal": "#dc2626",
  "Hertz": "#06b6d4",
  "Morel": "#8b5cf6",
  "Infinity": "#6366f1",
  "Pioneer": "#f43f5e",
  "Kenwood": "#14b8a6",
  "Sony": "#1e293b",
  "Memphis Audio": "#eab308",
  "Massive Audio": "#ef4444",
  "SoundQubed": "#84cc16",
  "Wolfram Audio": "#6b7280",
  "American Bass": "#dc2626",
  "Deaf Bonce": "#a3e635",
  "Timpano": "#f59e0b",
  "PRV Audio": "#2563eb",
  "DS18": "#f97316",
  "Audison": "#0f172a",
  "JBL": "#f97316",
};

interface ProductThumbnailProps {
  product: Product;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const SIZES = {
  sm: { box: 40 },
  md: { box: 56 },
  lg: { box: 72 },
};

const ProductThumbnail = ({ product, size = "md", className = "" }: ProductThumbnailProps) => {
  const brandColor = BRAND_COLORS[product.brand] ?? "#888888";
  const dims = SIZES[size];
  const imageUrl = getProductImage(product);

  return (
    <div
      className={`shrink-0 rounded-md overflow-hidden flex items-center justify-center ${className}`}
      style={{
        width: dims.box,
        height: dims.box,
        background: `${brandColor}12`,
        border: `1px solid ${brandColor}30`,
      }}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={`${product.brand} ${product.model}`}
          className="w-full h-full object-contain"
          loading="lazy"
        />
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center px-1 text-center">
          <span className="text-[8px] font-mono uppercase tracking-wider text-muted-foreground">Exact</span>
          <span className="text-[9px] font-mono font-bold uppercase text-foreground">Photo</span>
          <span className="text-[8px] font-mono uppercase tracking-wider text-muted-foreground">Unavailable</span>
        </div>
      )}
    </div>
  );
};

export default ProductThumbnail;
